import React from 'react';
import { useI18n } from '../i18n';
import { adminLocale, formatAdmin } from '../locales/admin';

const ScoringDiffPreview = ({ preview }) => {
    const { t, language } = useI18n();
    if (!preview) return null;
    const text = t.admin.scoring.diffPreview;
    const delta = `${preview.deltaSum >= 0 ? '+' : ''}${preview.deltaSum}`;
    return (
        <div>
            <p style={{ margin: '0 0 0.75rem', color: '#444', fontSize: '0.9rem' }}>
                {formatAdmin(t, text.summary, {
                    sessions: preview.sessionCount,
                    results: preview.resultCount,
                    changedResults: preview.changedResults,
                    changedSessions: preview.changedSessions,
                    oldSum: preview.oldSum,
                    newSum: preview.newSum,
                    delta
                })}
            </p>
            {preview.sample && preview.sample.length > 0 ? (
                <div style={{ overflowX: 'auto', maxHeight: '280px', overflowY: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
                        <thead>
                            <tr style={{ textAlign: 'left', background: '#f5f0e6' }}>
                                <th style={{ padding: '0.4rem', border: '1px solid #ddd' }}>{text.date}</th>
                                <th style={{ padding: '0.4rem', border: '1px solid #ddd' }}>{text.game}</th>
                                <th style={{ padding: '0.4rem', border: '1px solid #ddd' }}>{text.player}</th>
                                <th style={{ padding: '0.4rem', border: '1px solid #ddd' }}>{text.rank}</th>
                                <th style={{ padding: '0.4rem', border: '1px solid #ddd' }}>{text.old}</th>
                                <th style={{ padding: '0.4rem', border: '1px solid #ddd' }}>{text.new}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {preview.sample.map((row, idx) => (
                                <tr key={`${row.sessionId}-${row.playerId}-${idx}`}>
                                    <td style={{ padding: '0.35rem', border: '1px solid #eee' }}>
                                        {row.date ? new Date(row.date).toLocaleDateString(adminLocale(language)) : '–'}
                                    </td>
                                    <td style={{ padding: '0.35rem', border: '1px solid #eee' }}>{row.gameName || '–'}</td>
                                    <td style={{ padding: '0.35rem', border: '1px solid #eee' }}>{row.playerName}</td>
                                    <td style={{ padding: '0.35rem', border: '1px solid #eee' }}>{row.rank}</td>
                                    <td style={{ padding: '0.35rem', border: '1px solid #eee' }}>{row.oldPoints}</td>
                                    <td style={{ padding: '0.35rem', border: '1px solid #eee', fontWeight: 600 }}>{row.newPoints}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {preview.sampleTruncated && (
                        <p style={{ fontSize: '0.8rem', color: '#888' }}>{text.truncated}</p>
                    )}
                </div>
            ) : (
                <p style={{ color: '#666', fontSize: '0.9rem' }}>{text.noChanges}</p>
            )}
        </div>
    );
};

export default ScoringDiffPreview;
